// extracted by mini-css-extract-plugin
module.exports = {"digital_wallet_placeholder":"styles_digital_wallet_placeholder__KfRpq","button-loading-spinner":"styles_button-loading-spinner__49X5Z"};